
<script>
import { defineComponent, inject } from 'vue'
import { useRoute } from 'vue-router'
import ParallaxImage from '@kit/components/ParallaxImage.vue'
import Column from '@kit/components/Column.vue'
import { getCurrentYear, cmsasset } from '@kit/utils/Formats'

export default defineComponent({
  name: "Footer",

  setup() {

    const route = useRoute()

    const hydrate = inject("hydrate")

    const { prefetch } = hydrate({
      prefetch:["common"],
    })

    return { prefetch, getCurrentYear, cmsasset }

  },

  components: {
    ParallaxImage,
    Column
  }

});
</script>

<style scoped>

  .center-info-area {
    width: 800px !important;
    background: linear-gradient(180deg,rgba(42, 40, 103, 0.8) 0%, rgba(74, 80, 142, 0.8) 100%);
    height:600px;
    backdrop-filter: blur(10px);
  }

  .gradient-overlay {
     background:linear-gradient(90deg, rgba(167, 197, 249, 0.4) 0%, rgba(112, 122, 187, 0.8) 70%);
  }


</style>

<template>

  <div class="sb sb-v footer sb-gr">

    <Column tag="div" :ltS="100" :ltP="100" :ltT="100" :ltD="100" :gtB="1000" :gtH="1200" class="sb sb-v">
      
      <div class="sb sb-h sb-align-ch" style="padding-top:40px;">
        <ParallaxImage :theme='{ parallax:{ background: { width:950, height:850 }}}' ariaImgLabel="background image for footer" src="/cms-static-assets/2026/04/DSC_0199-xsizes-1024.jpg"/>
        <div class="sb sb-spread gradient-overlay"></div>

        <div class="sb sb-v sb-explicit center-info-area">
          <div class="sb sb-v sb-explicit sb-alt2 sb-align-c" style="padding-top:30px; padding-bottom:30px;">
          
            <template v-if="prefetch && prefetch.common">
              
              <div class="sb sb-text sb-explicit" style="width: 200px;">
                <img :src="cmsasset(prefetch.common.footer.logo_image.guid)" style="object-fit:contain; width:100%; height:auto;" alt="fbicc logo image">
              </div>

              <div class="sb sb-v sb-g20" v-html="prefetch.common.footer.footer_html"></div>

              <p class="sb sb-text fbicc-footer-small-text">© {{ getCurrentYear() }} FBICC</p>

            </template>
          
          </div>
        </div>

      </div>
      
    </Column>
  </div>

</template>